import {JsonProperty} from '../shared/decorators/json-property';

export class BannedUser {
  @JsonProperty('user_id')
  id: number;
  email: string;
  username: string;
  chat: number;
  login: number;
  @JsonProperty('trade')
  order: number;
  withdraw: number;
  constructor(user?: any) {
    this.id = user ? user.id : undefined;
    this.email = user ? user.email : undefined;
    this.username = user ? user.username : undefined;
    this.chat = user ? user.chat : undefined;
    this.login = user ? user.login : undefined;
    this.order = user ? user.order : undefined;
    this.withdraw = user ? user.withdraw : undefined;
  }
}

export class BannedClassificationUser {
  @JsonProperty('user_id')
  id: number;
  email: string;
  username: string;
  classify: number;
  @JsonProperty('trade_type')
  tradeType: number;
  symbol: string;
  market: string;
  @JsonProperty('win_time')
  winTime: number;
  @JsonProperty('total_trade')
  totalTrade: number;
  performance: number;
  @JsonProperty('time_trade_windown')
  timeTradeWindown: number;
  profit: number;
  time: number;
  constructor() {
    this.id = undefined;
    this.email = undefined;
    this.username = undefined;
    this.classify = undefined;
    this.tradeType = undefined;
    this.symbol = undefined;
    this.market = undefined;
    this.winTime = undefined;
    this.totalTrade = undefined;
    this.performance = undefined;
    this.timeTradeWindown = undefined;
    this.profit = undefined;
    this.time = undefined;
  }

  getClassify(): string {
    switch (this.classify) {
      case 1:
        return '<span class="text-red">High</span>';
      case 2:
        return '<span class="text-yellow">Moderate</span>';
      case 3:
        return '<span class="text-green">Low</span>';
    }
  }

  getTradeType(): string {
    return this.tradeType === 1 ? 'Manual' : 'EA';
  }
}
